module.exports = __webpack_public_path__ + "/build/web/images/hero-article.611cd8814fc1af272d82c4804f0a2fd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/hero-article.jpg
// module id = 136
// module chunks = 13